export default "__VITE_ASSET__EUR0zGZL__"